import { CONTENT_TYPES } from '@/services/contentful/constants'
import { PAGE_LIST, WEBSITE_NAMES } from 'constants/websites'

export const getPageContentTypes = () => {
  const siteEnv = process.env.NEXT_PUBLIC_SITE_ENVIRONMENT as keyof typeof PAGE_LIST
  return PAGE_LIST[siteEnv] || PAGE_LIST.default
}

export const articleContentTypeBySite = () => {
  const { websiteField } = getPageContentTypes()
  let content_type = CONTENT_TYPES.LONG_FORM_CONTENT
  if (websiteField === WEBSITE_NAMES.BILLS) {
    content_type = CONTENT_TYPES.LONG_FORM_CONTENT_BILLS
  }
  return content_type
}
